/****   http.js   ****/
// 导入封装好的axios实例
import request from "./request.js";
// import qs from "qs";

/**
 * methods: 请求
 * @param url 请求地址
 * @param params 请求参数
 */
function get(url, params, headers_config) {
  const config = {
    method: "get",
    url: url,
    headers_config: headers_config,
  };
  //公共参数
  // params['token'] = sessionStorage.getItem("token-assessment");
  // params['power_id'] = router.history.current.query.powerId;
  if (params) config.params = params;
  return request(config);
}

function post(url, params, headers_config) {
  const config = {
    method: "post",
    url: url,
    headers_config: headers_config,
  };
  //公共参数
  // params['token'] = sessionStorage.getItem("token-assessment");
  // params['power_id'] = router.history.current.query.powerId;
  if (params) config.data = params;
  return request(config);
}

function postFlie(url, params, headers_config) {
  const config = {
    method: "post",
    url: url,
    headers_config: headers_config,
  };
  //公共参数
  // params['token'] = sessionStorage.getItem("token-assessment");
  // params['power_id'] = router.history.current.query.powerId;
  if (params) config.data = params;
  return request(config);
}

function deletes(url, params, headers_config) {
  const config = {
    method: "delete",
    url: url + "/" + params.ids,
    headers_config: headers_config,
  };
  if (params) config.data =params;
  return request(config);
}

function deletescode(url, params, headers_config) {
  const config = {
    method: "delete",
    url: url + "/" + params.type + "/" + params.code,
    headers_config: headers_config,
  };
  if (params) config.data =params;
  return request(config);
}

function downloadUrl(url) {
  const config = {
    method: "get",
    url: url,
    responseType: "blob",
  };
  return request(config);
}
function put(url, params) {
  const config = {
    methods: "put",
    url: url,
  };
  if (params) config.params = params;
  return request(config);
}

//导出
export default {
  get,
  post,
  deletes,
  downloadUrl,
  put,
  postFlie,
  deletescode
};
